export default __webpack_public_path__ + "static/media/bronzer.01bf9c49.jpg";